export const AusComparisonTestIds = {
  AUS_TYPE_RADIO: 'aus-comparison.aus-type-radio',
};
